import React from 'react';
import { PARTNERS } from '../data/mock';

export default function Marquee() {
  return (
    <section className="relative py-20 border-y border-white/8 bg-[#040604]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-8 grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-7">
          <div className="pin-num mb-4"> Who Joins SAMZ</div>
          <h3 className="font-display text-white text-[30px] md:text-[40px] leading-[1.05] tracking-[-0.03em]">
            Every Discipline. One Empowerment Zone.
          </h3>
        </div>
        <div className="lg:col-span-5 lg:pl-8">
          <p className="text-white/60 text-[14.5px] leading-[1.7] max-w-[420px]">
            SAMZ serves the entire U.S. creative economy across music, fashion, media, and entertainment. If you make something the world should hear or see, this is built for you.
          </p>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="marquee">
          {[...PARTNERS, ...PARTNERS].map((p, i) => (
            <div
              key={i}
              className="flex items-center gap-3 text-white/45 text-[22px] tracking-[0.22em] font-display uppercase whitespace-nowrap hover:text-[#22A773] transition-colors"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#22A773]/40" />
              {p}
            </div>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#040604] to-transparent" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#040604] to-transparent" />
      </div>
    </section>
  );
}
